import { useState } from 'react';
import { Typography } from 'antd';
import { EnvironmentTwoTone } from '@ant-design/icons';

import { CONTACT_COLUMNS, CONTACT_COLUMNS_AG } from './constants';

import { sleep } from 'utils/delay';

export const useContact = ({ propsData }) => {
  const [contactList, setContactList] = useState(() => {
    return (propsData?.id ? [{ ...propsData }] : [])?.map((product) => {
      return { ...product, key: product?.id };
    });
  });

  const handleDeleteDataSource = (key) => {
    const filter = contactList.filter((item) => item?.key !== key);
    setContactList(filter);
  };

  const addData = (contact) => {
    setContactList((pre) => {
      const key = pre[pre?.length - 1]?.key ? pre[pre?.length - 1]?.key + 1 : 1;

      return [...pre, { ...contact, key }];
    });
  };

  const editData = (currentContact) => {
    setContactList((pre) => {
      return pre?.map((item) => {
        return item?.key === currentContact?.key
          ? {
              ...currentContact,
              id: propsData?.id ? item?.key : null,
            }
          : item;
      });
    });
  };

  return {
    contactList: contactList,
    addData,
    editData,
    handleDeleteDataSource,
  };
};

export const useContactColumns = (hiddenFields = []) => {
  const columns = mappingColumns(CONTACT_COLUMNS, hiddenFields);

  const filter = columns?.filter(
    (item) => !hiddenFields.includes(item?.dataIndex)
  );

  return {
    columns: filter,
  };
};

export const useGetContactColumnsDef = (setVisibleAssociateLocal) => {
  const columnsDef = [
    {
      field: '',
      checkboxSelection: true,
      filter: false,
      suppressMenu: true,
      width: 50,
      resizable: true,
    },
    ...CONTACT_COLUMNS_AG,
    {
      dataType: 'string',
      headerName: 'Associated Locations',
      fieldName: 'associateLocationIds',
      field: 'associateLocationIds',
      fieldNameCamelCase: 'associateLocationIds',
      allowFilter: true,
      allowSort: true,
      width: 180,
      cellRenderer: ({ data }) => (
        <RenderAssociatedLocations
          data={data}
          setVisibleAssociateLocal={setVisibleAssociateLocal}
        />
      ),
      resizable: true,
    },
    {
      dataType: 'Boolean',
      headerName: 'Is Product Hub User',
      fieldName: 'isProductHubUser',
      fieldNameCamelCase: 'isProductHubUser',
      allowFilter: true,
      allowSort: true,
      valueGetter: ({ data }) => {
        return data?.isProductHubUser ? 'Yes' : 'No';
      },
      resizable: true,
    },
  ];

  return { columnsDef };
};

export const mappingColumns = (columns) => {
  return columns.map((item) => {
    const { title, fieldName, width } = item || {};
    return {
      title: <Typography.Text strong>{title}</Typography.Text>,
      dataIndex: fieldName,
      width: width ?? 150,
      render: (value, _) => {
        return (
          <Typography.Text ellipsis={{ tooltip: value }}>
            {value}
          </Typography.Text>
        );
      },
    };
  });
};


export const RenderAssociatedLocations = ({
  data,
  setVisibleAssociateLocal,
}) => {
  return (
    <>
      {data?.associateLocationIds?.length > 0 ? (
        <EnvironmentTwoTone
          style={{ fontSize: 16, cursor: 'pointer' }}
          onClick={async () => {
            await sleep(100);
            setVisibleAssociateLocal(true);
          }}
        />
      ) : (
        ''
      )}
    </>
  );
};
